import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSyncQueryCache } from './useSyncQueryCache'
export interface DynamoDBItemUpdate {
  tableName: string
  PK: string
  SK: string
  fieldName: string
  newValue: string | string[] | boolean | object[] // supports enriched arrays like user objects
}

export const updateFields = async ({ updates }) => {
  console.log('[updateFields] called with updates: ', updates)
  const url = `${baseUrl}/aws/update/fields`
  try {
    const response = await axios.put(url, { updates })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update items:', error)
    throw error
  }
}
export const useUpdateFields = () => {
  const queryClient = useQueryClient()
  const { patchOrganizationFieldsInCache, syncDealFields } = useSyncQueryCache()

  return useMutation({
    mutationFn: updateFields,
    onSuccess: (_data, variables) => {
      const ups = variables?.updates ?? []

      const orgByKey = new Map<string, { fieldName: string; newValue: any }[]>()
      for (const u of ups) {
        if (u.SK?.startsWith('CREATION_TIMESTAMP_')) {
          const key = `${u.PK}::${u.SK}`
          if (!orgByKey.has(key)) orgByKey.set(key, [])
          orgByKey.get(key)!.push({ fieldName: u.fieldName, newValue: u.newValue })
        }
      }
      // ✅ no for..of on Map
      orgByKey.forEach((patches, key) => {
        const [PK, SK] = key.split('::')
        patchOrganizationFieldsInCache(queryClient, PK, SK, patches)
      })

      // DEALS
      const dealByKey = new Map<string, { fieldName: string; newValue: any }[]>()
      for (const u of ups) {
        if (u.SK?.startsWith('DEAL_')) {
          const key = `${u.PK}::${u.SK}`
          if (!dealByKey.has(key)) dealByKey.set(key, [])
          dealByKey.get(key)!.push({ fieldName: u.fieldName, newValue: u.newValue })
        }
      }
      // ✅ no for..of on Map
      dealByKey.forEach((patches, key) => {
        const [PK, SK] = key.split('::')
        syncDealFields(queryClient, { PK, SK } as any, patches)
      })
    },
    onError: err => console.error('[useUpdateFields] Error updating items:', err),
  })
}
// export const useUpdateFields = () => {
//   const queryClient = useQueryClient()
//   const { patchOrganizationFieldsInCache } = useSyncQueryCache()
//   const mutation = useMutation({
//     mutationFn: updateFields,
//     onSuccess: (data, variables) => {
//       console.log('[useUpdateFields] Updated items data:', data, 'VARIABLES: ', variables)
//       const orgStatusUpdates = variables?.updates?.filter(
//         u => u?.SK?.startsWith('CREATION_TIMESTAMP_') && u?.fieldName === 'onboardingStatus'
//       )
//       if (orgStatusUpdates?.length > 0) {
//         const orgPK = orgStatusUpdates?.[0]?.PK
//         const orgSK = orgStatusUpdates?.[0]?.SK
//         const patches = orgStatusUpdates
//           .filter(u => u.PK === orgPK && u.SK === orgSK)
//           .map(u => ({ fieldName: u.fieldName, newValue: u.newValue }))
//         patchOrganizationFieldsInCache(queryClient, orgPK, orgSK, patches)
//       }
//     },
//     onError: error => {
//       console.error('[useUpdateFields] Error updating items:', error)
//     },
//   })

//   return mutation
// }
